<ng-content select="wma-drawer-sidenav" />

<div class="flex w-0 flex-1 flex-col overflow-hidden">
  <ng-content select="wma-drawer-content" />
</div>
